import { render } from "./ExamReportImagesModal.vue?vue&type=template&id=47373a84&scoped=true"
import script from "./ExamReportImagesModal.vue?vue&type=script&lang=js"
export * from "./ExamReportImagesModal.vue?vue&type=script&lang=js"

import "./ExamReportImagesModal.vue?vue&type=style&index=0&id=47373a84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47373a84"]])

export default __exports__